module.exports = __webpack_public_path__ + "static/media/ManifestFileTemplate.80e5e2f1.xls";


//////////////////
// WEBPACK FOOTER
// ./src/Regional-Views/DataEntry/ManifestFileTemplate.xls
// module id = 479
// module chunks = 0